// src/pages/collaborators/AcceptCollaboratorInvite.jsx
// Flux : token présent → user connecté → accept_collaborator_invitation
//        token présent → user NON connecté → RegisterCollaborator (pas /login standard)
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";

export default function AcceptCollaboratorInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("idle"); // idle | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    async function run() {
      if (!token) {
        setStatus("error");
        setMessage("Lien d'invitation invalide : token manquant.");
        setLoading(false);
        return;
      }

      const { data: sess } = await supabase.auth.getSession();

      if (!sess?.session) {
        // ✅ Rediriger vers la page d'inscription collaborateur (gratuite, sans abo)
        // au lieu de /login qui enverrait vers l'inscription payante
        navigate(
          `/collaborators/register?token=${encodeURIComponent(token)}`,
          { replace: true }
        );
        return;
      }

      // User déjà connecté → accepter directement
      setLoading(true);
      const { error } = await supabase.rpc("accept_collaborator_invitation", {
        p_token: token,
      });

      if (error) {
        setStatus("error");
        const msg = (error.message || "").toLowerCase();
        if (msg.includes("email mismatch")) {
          setMessage("Cet email ne correspond pas à l'invitation. Connectez-vous avec l'adresse email invitée.");
        } else if (msg.includes("invalid token")) {
          setMessage("Token invalide ou expiré.");
        } else if (msg.includes("not pending")) {
          setMessage("Invitation déjà utilisée ou annulée.");
        } else {
          setMessage(error.message || "Impossible d'accepter l'invitation.");
        }
      } else {
        setStatus("ok");
        setMessage("Invitation acceptée. Bienvenue 🗝️");
        setTimeout(() => navigate("/dashboard", { replace: true }), 900);
      }

      setLoading(false);
    }

    run();
  }, [token, navigate]);

  const cardStyle = {
    maxWidth: 480,
    margin: "80px auto",
    padding: "32px 36px",
    background: "#fff",
    border: "1px solid #e5e3df",
    fontFamily: "system-ui, sans-serif",
  };

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", background: "#fafaf8", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p style={{ fontFamily: "Georgia, serif", color: "#6b6b6b" }}>Validation en cours…</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#fafaf8", padding: "16px" }}>
      <div style={cardStyle}>
        <h1 style={{ fontFamily: "Georgia, serif", fontWeight: 400, fontSize: 22, color: "#1a1a1a", marginBottom: 16 }}>
          Invitation collaborateur
        </h1>

        {status === "ok" && (
          <>
            <p style={{ fontSize: 14, color: "#065f46", lineHeight: 1.7 }}>{message}</p>
            <p style={{ fontSize: 13, color: "#9a8c7e", marginTop: 8 }}>Redirection vers le tableau de bord…</p>
          </>
        )}

        {status === "error" && (
          <>
            <div style={{ padding: "12px 16px", background: "#fef2f2", border: "1px solid #fecaca", marginBottom: 20 }}>
              <p style={{ color: "#b00020", fontSize: 14, margin: 0 }}>{message}</p>
            </div>
            <Link
              to="/dashboard"
              style={{ display: "inline-block", padding: "10px 20px", background: "#1a1a1a", color: "#fff", textDecoration: "none", fontSize: 14, fontFamily: "system-ui, sans-serif" }}
            >
              Aller au tableau de bord
            </Link>
          </>
        )}
      </div>
    </div>
  );
}